import React, { useEffect, useState } from 'react';
import { Box, Container } from '@mui/material';
import SearchList from './searchList/SearchList';
import MenuSearchPage from './MenuSearchPage';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as REQUEST_REQUIREMENTS from '../../../app/api/requestRequirements';

const BG_MAIN = '#15151a';

export default function Search() {
    const { queryType } = useParams();
    const [searchQueryType, setSearchQueryType] = useState(queryType);
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const query = params.get('q');

    useEffect(() => {
        if (query) {
            const PRIVATE_ROUTES = REQUEST_REQUIREMENTS.handlePrivateRoutes({
                ROUTE_PARAMS: {
                    queryType: searchQueryType,
                    searchInputQuery: query,
                },
            });

            navigate(PRIVATE_ROUTES.SEARCH_BAR_NAVIGATION);
        }
    }, [searchQueryType]);

    useEffect(() => {
        setSearchQueryType('users');
    }, [query]);

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: BG_MAIN, py: { xs: 2, sm: 3 } }}>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: { xs: 2, md: 3 },
                    }}
                >
                    <Box sx={{ width: { xs: '100%', md: 200 }, flexShrink: 0 }}>
                        <MenuSearchPage
                            optionClicked={searchQueryType}
                            onClickOption={setSearchQueryType}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <SearchList searchType={searchQueryType} query={query} />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}
